const wrapperCls = "_araw1kriipk";
const imageWrapperCls = "_arai12uwiir";
const imageCls = "_arai12h7u9k";
const badgeCls = "_arabrn4e3b";
const headingCls = "_arahm2vs9j";
const standaloneChevronWrapper = "_aras25wu8w";
const chevronCls = "_arac1yuaazk";
const descriptionCls = "_arad13cueij";
const checkmark = "_arachsxlhg";

export { badgeCls, checkmark, chevronCls, descriptionCls, headingCls, imageCls, imageWrapperCls, standaloneChevronWrapper, wrapperCls };
import "./lightbox.preview.style.linaria.module.css";
//# sourceMappingURL=lightbox.preview.style.js.map
